<template>
  <div class="wrapper">
    <div class="container">
      <img src="../assets/images/icon-success.png" class="icon" />
      <p>您的备案已提交审核，在备案审核期间请保持电话通畅，并留意短信通知。</p>
      <p>详细审核流程请查看<a href="https://developers.weixin.qq.com/miniprogram/product/record/guidelines.html" target="_blank">《微信小程序备案审核流程》</a></p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'storeList',
  data() {
    return {
      
    }
  },
  created() {
    
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.container{
  height: 100%;
  padding-top: 1px;
  .icon{
    width: 60px;
    height: 60px;
    display: block;
    margin: 100px auto 20px;
  }
  p{
    line-height: 20px;
    font-size: 14px;
    color: #666;
    text-align: left;
    margin: 0 25px 10px;
  }
  a{
    font-size: 14px;
    color: #47B6C7;
  }
}
.jump-btn{
  line-height: 1.4;
  font-size: 16px;
  color: #47B6C7;
  text-align: center;
  display: block;
  margin-left: 12px;
}
</style>


// WEBPACK FOOTER //
// src/views/filing-success.vue